<template>
    <div class="bg-no-repeat bg-fit md:bg-none bg-[url('/images/2.0/login/footer-bg.svg')] bg-bottom z-0">
        <div class="hidden md:block fixed z-10 left-1/2 -translate-x-1/2 top-10 sm:top-5 md:top-10 md:left-10 md:translate-x-0">
            <a href="/"><img src="images/2.0/guest-logo.svg" alt="Invelo Hero" class="md:w-full w-32"></a>
        </div>
        <div class="min-h-screen border flex flex-col justify-center items-center pt-6 sm:pt-0 md:bg-gray-100 dark:bg-gray-900 bg-no-repeat bg-cover md:bg-[url('/images/2.0/login/bg.svg')] bg-top py-4">
            <div class="z-20">
                <div class="w-full md:hidden flex justify-center py-4">
                    <a href="/"><img src="images/2.0/guest-logo.svg" alt="Invelo Hero" class="md:w-full w-32"></a>
                </div>
                <div class="max-w-2xl m-auto w-full z-10 md:px-4">
                    <!-- <div v-if="hasmigrationcta" class="max-w-2xl m-auto w-full z-10 px-4 pt-4 mb-4">
                        <LayoutNewGuestMigrationFlagLogin />
                    </div> -->
                    <div class="shadow-xl w-full rounded-4xl md:py-8 py-4 md:px-16 px-6 space-y-6 bg-white">
                        <slot />
                    </div>
                </div>
            </div>
            <div class="fixed hidden md:block bottom-0 w-full h-[100vh] bg-no-repeat bg-[url('/images/2.0/login/footer-bg.svg')] bg-bottom bg-fit md:bg-contain z-0" />
            <div class="md:absolute py-5 md:py-0 bottom-0 md:pb-2 pb-2 text-center text-white text-xs md:text-sm">
                <a href="/privacy-policy" class="underline hover:no-underline">Privacy Policy</a> and <a href="/terms-of-service" class="underline hover:no-underline">Terms of Service</a>
            </div>
        </div>
    </div>
</template>

<script setup>
defineProps({
    hasmigrationcta: {
        type: Boolean,
        default: true
    },
});
onMounted(() => {
    window.fpr = window.fpr || function(){
        window.fpr.q = window.fpr.q || [];
        window.fpr.q[arguments[0] === 'set' ? 'unshift' : 'push'](arguments);
    };
    window.fpr('init', { cid: 'jwf51zru' });
    window.fpr('click');
    const script = document.createElement('script');
    script.src = 'https://cdn.firstpromoter.com/fpr.js';
    script.async = true;
    document.body.appendChild(script);

    // Google Tag setup
    const gtagScript = document.createElement('script');
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-10861711321';
    gtagScript.async = true;
    document.head.appendChild(gtagScript);

    gtagScript.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag(){ dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', 'AW-10861711321');
    };
});
</script>
<style>
    /* Media query for mobile */
    @media (max-width: 768px) {
        body {
            background: url('/images/2.0/login/bg.svg') top center no-repeat;
            background-size: cover;
        }
    }
</style>
